"use client";

import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Architecture from "@/components/Architecture";
import SystemDesign from "@/components/SystemDesign";

export default function ArchitecturePage() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-28 pb-10">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(99,102,241,0.04)_1px,transparent_1px),linear-gradient(to_bottom,rgba(99,102,241,0.04)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] -z-10 opacity-60" />
        
        {/* Render both architecture systems and system design flows */}
        <Architecture />
        <div className="h-1 bg-white/5 my-10 max-w-7xl mx-auto rounded-full opacity-50" />
        <SystemDesign />
      </main>
      <Footer />
    </>
  );
}
